module.exports = __webpack_public_path__ + "img/sge.28201ba2.svg";